// Typelizer digest 8a3db4af28777dfdcc233c0cc7ad1f8f
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /account/password/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/account/password/new', {}, options),
    method: 'get',
  }),

  /** GET /account/password/edit */
  edit: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/account/password/edit', {}, options),
    method: 'get',
  }),

  /** PATCH /account/password */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/account/password', {}, options),
    method: 'patch',
  }),

  /** POST /account/password */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/account/password', {}, options),
    method: 'post',
  }),
}
